import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=59a2d6c6&scoped=true"
var script = {}
import style0 from "./Impressum.vue?vue&type=style&index=0&id=59a2d6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a2d6c6",
  null
  
)

export default component.exports